module.exports = __webpack_public_path__ + "static/media/05.15e64fd7.png";